<template>
  <div class="container">
    <!-- Header -->
    <div class="header">
      <div class="header-left">
        <Skeleton width="250px" height="28px" />
      </div>
      <div class="header-right">
        <Skeleton width="180px" height="28px" class="mb-1" />
        <Skeleton width="280px" height="14px" />
      </div>
    </div>

    <!-- Action Buttons -->
    <div class="action-buttons">
      <Skeleton width="110px" height="38px" class="mr-2" border-radius="4px" />
      <Skeleton width="130px" height="38px" border-radius="4px" />
    </div>

    <!-- Info Grid -->
    <div class="info-grid">
      <div v-for="i in 4" :key="i" class="info-item">
        <Skeleton width="140px" height="16px" class="title-skeleton" />
        <div class="mt-2">
          <Skeleton width="180px" height="16px" class="mb-1" />
          <Skeleton v-if="i > 2" width="160px" height="16px" />
        </div>
      </div>
    </div>

    <!-- Costs Table -->
    <div class="cost-table-skeleton">
      <Skeleton width="280px" height="16px" class="mb-4" />
      <div v-for="i in 3" :key="i" class="cost-row">
        <Skeleton width="75%" height="16px" />
        <Skeleton width="100px" height="16px" />
      </div>
    </div>

    <!-- Attachments -->
    <div class="attachments">
      <Skeleton width="160px" height="16px" class="title-skeleton" />
      <div v-for="i in 2" :key="i" class="attachment-item">
        <Skeleton width="320px" height="38px" border-radius="4px" />
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
import Skeleton from "primevue/skeleton";
</script>

<style scoped>
.container {
  max-width: 800px;
  margin: 0 auto;
  background-color: #f7f0fa;
  border-radius: 6px;
  box-shadow: 0 0 6px rgba(0, 0, 0, 0.1);
  padding: 24px;
}

.header {
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
  padding-bottom: 8px;
  margin-bottom: 16px;
  border-bottom: 1px solid #eee;
}

.header-right {
  text-align: right;
}

.action-buttons {
  margin: 24px 0;
  display: flex;
  gap: 12px;
}

.info-grid {
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  gap: 24px;
  margin: 24px 0;
}

.info-item {
  padding-top: 8px;
}

.title-skeleton {
  position: relative;
}

.title-skeleton::after {
  content: "";
  position: absolute;
  bottom: -4px;
  left: 0;
  width: 100%;
  height: 1px;
  background-color: #bbb;
}

.cost-table-skeleton {
  margin: 32px 0;
}

.cost-row {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 12px 0;
}

.attachments {
  padding-top: 24px;
  border-top: 1px solid #eee;
}

.attachment-item {
  margin: 12px 0;
}

:deep(.p-skeleton) {
  background-color: #e9ecef;
}
</style>
